import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  HostListener,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { InputComponent } from "../input/input.component";

@Component({
    selector: "search-component",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"],
    standalone: false
})
export class SearchComponent implements OnInit {
  showSearchInput: boolean;
  searchText: String = "";
  show = false;
  @Output() valueChange = new EventEmitter();
  @ViewChild('searchInput') searchInput!: InputComponent;

  constructor(private eRef: ElementRef) {}

  ngOnInit() {}

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      this.showSearchInput = true;
    } else if (this.searchText == "") {
      this.showSearchInput = false;
    }
  }

  public clearSearch() {
    this.searchText = "";
    this.dataChanged(this.searchText);
    this.searchInput.focus();
  }

  public dataChanged(searchText) {
    this.valueChange.emit(searchText);
  }
}
